import { ActionReducer, Action } from '@ngrx/store';
import { merge, pick } from 'lodash-es';
import * as SecureLS from 'secure-ls';
import { environment } from '../../../environments/environment';

const ls = new SecureLS({ encodingType: 'rc4', isCompression: false, encryptionSecret: environment.LS_SECRET });

const isProd = environment.PRODUCTION;

// the key for the local storage.
export const localStorageKey = '__app_storage__';

// the keys from state which we'd like to save.
const enabledStorageKeys = ['auth'];

export function setSavedState(state: any) {
  try {
    if (isProd) {
      ls.set(localStorageKey, state);
    } else {
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    }
  } catch (e) {
  }
}

export function getSavedState(): any {
  try {
    if (isProd) {
      return ls.get(localStorageKey);
    } else {
      return JSON.parse(localStorage.getItem(localStorageKey));
    }
  } catch (e) {
    return '';
  }
}

export function storageMetaReducer<S, A extends Action = Action>(reducer: ActionReducer<S, A>) {
  let onInit = true; // after load/refresh…

  return (state: S, action: A): S => {

    // reduce the nextState.
    const nextState = reducer(state, action);

    // init the application state.
    if (onInit) {
      onInit = false;
      const savedState = getSavedState();
      return merge(nextState, savedState);
    }

    // save the next state to the application storage.
    const stateToSave = pick(nextState, enabledStorageKeys);
    setSavedState(stateToSave);
    return nextState;
  };
}
